import styled from 'styled-components';

export const StyledBorrowReturnContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 300px;
`;

export const StyledBorrowReturnButton = styled.button`
  height: 110px;
  width: 110px;
  cursor: pointer;
  background-color: #c4c4c4;
  border-radius: 50%;
  font-family: 'NexonBo';
  text-align: center;
  font-size: 25px;
`;
